import axios from "axios";

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
const isLoggedIn = Boolean(localStorage.getItem("isLoggedIn"));
const token = localStorage.getItem("token");
if (isLoggedIn) {
  http.defaults.headers.common = { Authorization: `Bearer ${token}`,Accept: "application/json" };
}

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
        try {
          localStorage.removeItem("token");
          localStorage.setItem("isLoggedIn",false);
          window.location.href = "/auth/loginformik";
        } catch (ex) {
          //console.log(ex);
        }
      return Promise.reject();
    }

    return Promise.reject(error);
  }
);
export default http;